import React from "react";
import { Select } from "antd";


// @ts-ignore
const StateSelector = ({ value = null, onChange = (value) => {} }) => {

    const StatesChoices: string[] = ['PENDING', 'APPROVED', 'ERROR', 'REJECTED'];

    return (
        <Select
            allowClear
            value={value}
            onChange={(selectedValues) => onChange(selectedValues)}
            placeholder="Select State"
            style={{ width: "200px" }}
            options={StatesChoices.map((item) => ({value: item, label: item}))}
        />
    );
};

export default StateSelector;